export default "__VITE_ASSET__Zh8q$LLP__"